module.exports = __webpack_public_path__ + "static/media/kominfo-team-4.e5c32b4a.png";